<template>
  <div class="itemCartFrameContainer">
    <div class="itemCartFrameTopContainer"  @click="goToDetails()">
      <NsBadge :overlap="true" :color="'#bb29bb'" class="iconContainer">
        <img v-if="itemThumbnailUrl !== ''" slot="badge-anchor" class="itemCartPicture" :src="image.src" />
        <NsIcon v-else slot="badge-anchor" class="itemCartPicture" icon-name="icon-product-placeholder-26" />
      </NsBadge>
      <div class="itemCartName">{{ title }}</div>
    </div>
    <div v-if="showPrices" class="itemCartFrameBottomContainer">
      <span class="itemCartFramePrice">
        {{ itemPrice }}
      </span>
      <span class="itemCartFramePrice itemCartFrameSVPrice">
        {{ pvString }}: {{ itemPoints }}
      </span>
    </div>
  </div>
</template>

<script>
import { NsIcon } from '@nuskin/ns-icon'
import {
  NsBadge,
} from '@nuskin/design-components'
import { NsProductMixin } from '@nuskin/product-components'
import { StringService } from '@nuskin/ns-util'
export default {
  components: {
    NsIcon,
    NsBadge,
  },
  computed: {
    itemPrice() {
      return aem.CurrencyService.format(this.price)
    },
    itemPoints() {
      return parseFloat(this.points).toFixed(2)
    }
  },
  mixins: [NsProductMixin],
  props: {
    showPrices: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setCommonStrings() {
      const commonStrings = [
        { key: 'psvDist', dflt: '' },
        { key: 'psvCust', dflt: '' },
        { key: 'psvPfc', dflt: '' },
        { key: 'psvAnon', dflt: '' },
      ]
      StringService.getStrings(commonStrings).then((strings) => {
        switch (this.user.accountType) {
          case '10':
            this.pvString = strings.psvDist
            break
          case '20':
            this.pvString = strings.psvCust
            break
          case '30':
            this.pvString = strings.psvPfc
            break
          default:
            this.pvString = strings.psvAnon
            break
        }
      })
    },
  },
  mounted() {
    this.setCommonStrings()
  }
}
</script>

<style lang="scss">
.itemCartFrameContainer {
  margin-top: 15px;
  .itemCartFrameTopContainer {
    align-items: center;
    display: flex;
    justify-self: flex-start;
    cursor: pointer;
    .itemCartPicture {
      height: 30px;
      width: 30px;
    }
    .itemCartName {
      color: #272525;
      font-size: 14px;
      font-weight: 400;
      margin-left: 15px;
      text-align: left;
    }
  }
  .itemCartFrameBottomContainer {
    padding-left: 30px;
    text-align: left;
    .itemCartFramePrice {
      color: #272525;
      font-size: 12px;
      font-weight: 600;
      margin-left: 15px;
    }
    .itemCartFrameSVPrice {
      color: #63666A;
    }
  }
}
</style>
